import styled from '@emotion/styled'
import { FieldContainer } from '../functional'
import { MuiOtpInput } from 'mui-one-time-password-input'
import { color, font, size, space } from '../../styles'

interface phoneNumberFieldProps {
   name: string
   numberOfCharacters: number
   onComplete: (value: string) => void
   disabled?: boolean
   gap?: number
}
const OTPField: React.FC<phoneNumberFieldProps> = (props) => {
   const { name, numberOfCharacters, onComplete, gap, disabled } = props

   return (
      <FieldContainer name={name}>
         {({ helperText, error, ...fieldProps }) => (
            <StyledMuiOtpInput
               onChange={(value) => fieldProps.onChange({ target: { name, value } })}
               value={fieldProps.value}
               length={numberOfCharacters}
               onComplete={onComplete}
               TextFieldsProps={{
                  disabled: disabled || fieldProps.disabled,
                  inputProps: {
                     pattern: '[0-9]*',
                     inputMode: 'numeric',
                  },
               }}
               gap={gap}
            />
         )}
      </FieldContainer>
   )
}

const StyledMuiOtpInput = styled(MuiOtpInput)`
   input {
      min-height: 52px;
      font-size: 40px;
      ${font.regular};
      text-align: center;
      color: ${color.green};
      padding-inline: 10px;
   }
`

export default OTPField
